<template>
  <div class="store_review_box">
    <div class="store_review_title">
      <CustomBreadcrumb />
    </div>
    <div class="store-info">
      <div class="store-info-review">Store Review</div>
      <div class="store-info-title">Store Info</div>
      <el-form :model="storeInfo" ref="storeInfo" class="store-info-form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="Business Email" prop="email">
              <el-input disabled v-model="storeInfo.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="phone" style="margin-left: 10px" prop="phone">
              <el-input disabled v-model="storeInfo.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="Store Type" prop="onlineShopType">
              <el-select disabled v-model="storeInfo.onlineShopType" placeholder="Store Type">
                <el-option v-for="(item, index) in storeType" :key="item.textTitle" :label="item.textTitle"
                  :value="index">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Store Name" style="margin-left: 10px" prop="storeName">
              <el-input disabled v-model="storeInfo.storeName"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Store Address" prop="storeAddress">
          <el-input disabled v-model="detailAddress" ></el-input>
        </el-form-item>
        <el-form-item label="Store Contact Name" prop="storeContactName">
          <el-input disabled v-model="storeInfo.storeContactName" ></el-input>
        </el-form-item>
      </el-form>
      <div v-if="brandTips.tips" class="brand-tips">
        <div class="brand-tips-img-border"><img class="brand-tips-img" :src="brandTips.brandImg"/></div>
        <div class="brand-tips-main">
          <div class="brand-tips-title">{{brandTips.brandName}}</div>
          <div class="brand-tips-text">Expected Ordering Store Types:</div>
          <div class="brand-tips-content">{{brandTips.tips}}</div>
        </div>
      </div>
      <div class="inp-list">
        <div class="inp-item">
          <div class="inp-item-title"> Store image</div>
          <div class="inp-item-cont inp-item-cont3">
            <p class="upload-tips-text">
              Exterior storefront image (displaying storefront logo and overallappearance) (.jpeg/.png/.jpg)
            </p>
            <div class="simple-head">
              <img class="store-image" v-for="(item,index) in storeInfo.exteriorStoreImageList" :key="index" :src="item" @click="handlePictureCardPreviewUrl(item)"/>
            </div>
            <p class="upload-tips-text upload-tips-text2">
              Interior store images (interior panoramic views) 2-5 Image (.jpeg/.png/.jpg)
            </p>
            <div class="simple-head">
              <img class="store-image" v-for="(item,index) in storeInfo.interiorStoreImageList" :key="index" :src="item" @click="handlePictureCardPreviewUrl(item)"/>
            </div>
          </div>
        </div>
        <div class="application-title">Please provide a brief introduction of the reason for your application</div>
        <el-input disabled v-model="storeInfo.reason" maxlength="200" show-word-limit type="textarea"/>

         <!-- 谷歌地址 -->
        <template v-if="isOperation">
          <div class="application-title google-maps-title">
              <div>
                Google Maps
              </div>
              <div>
                  Sales Rep/SR: <span>{{storeInfo.saleSdr?storeInfo.saleSdr:'NULL'}}</span>
              </div>
          </div>
          <el-input v-model="storeInfo.googleMapUrl" @blur="changeGoogleMapUrl" type="textarea"/>
          <div class="error-tips error-googleurl" v-if="mapsIncorrectFlag">
             {{mapsIncorrectTips}}
          </div>
        </template>

        <!-- 店铺报告 -->
        <div class="application-title store-report" v-if="!mapsIncorrectFlag">
          <span>Store Report</span> Check the report for detailed store data
        </div>
        <div class="store-report-btn" @click="gotoReport">
            Open Report
        </div>


      </div>



      <!-- 供应商审核部分 -->
      <div v-if="!isOperation && storeInfo.auditStatus===1" class="action">
        <div class="pass-button" @click="approved">Approved</div>
        <div class="reject-button" @click="reject">Adudit Reject</div>
      </div>
      <!-- 运营审核部分 -->
      <div v-if="isOperation && storeInfo.brandReviewStatus===1" class="action">
        <div class="pass-button" @click="approved">运营审核通过</div>
        <div class="reject-button" @click="reject">运营审核拒绝</div>
      </div>
      <!-- 供应商的审核拒绝展示原因 -->
      <div v-if="!isOperation && storeInfo.auditStatus===3" class="review-reject">
        <div class="review-reject-title">Audit Rejected</div>
        <div class="review-reject-text">
          <OrderRejectReason :orderRejectReason="auditReason" :title="'Reason for Rejection: '"/>
        </div>
      </div>
      <!-- 运营的审核拒绝展示原因 -->
      <div v-if="isOperation && storeInfo.brandReviewStatus===3" class="review-reject">
        <div class="review-reject-title">Audit Rejected</div>
        <div class="review-reject-text">
          <OrderRejectReason :orderRejectReason="auditReason" :title="'Reason for Rejection: '"/>
        </div>
      </div>
      <el-dialog :visible.sync="dialogVisible" id="el-dialog-img">
        <img style="width:100%;height:100%;object-fit:contain" :src="dialogImageUrl" alt="" />
      </el-dialog>
      <el-dialog :visible.sync="reviewDialogVisible" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="review-dialog-border">
          <div class="review-dialog-back" @click="back"><i class="el-icon-arrow-left"></i>Back</div>
          <div v-if="reviewType ===1" class="review-dialog-pass" >
            <div class="review-dialog-tips">Are you sure you have passed the review?</div>
            <div class="review-dialog-action">
              <div v-loading="loading" class="review-dialog-cancel" @click="cancle">Cancel</div>
              <div v-loading="loading" class="review-dialog-confirm" @click="confirm">Confirm</div>
            </div>
          </div>
          <div v-if="reviewType ===0" class="review-dialog-reject">
            <div class="review-dialog-tips">Reason for rejection<span>Select up to 5 reasons.</span></div>
            <!-- <div class="review-dialog-reason">
              <el-input @input="changeRejectReason" v-model="storeInfo.rejectReason" maxlength="200" show-word-limit type="textarea" :autosize="{ minRows: 2, maxRows: 4}" />
              <div v-if="showrejectReasonError" class="reject-reason-tips">Please enter reason for rejection</div>
            </div> -->
            <div class="review-dialog-desc">{{rejectionDesc}}</div>
            <div class="review-dialog-reason-list">
              <el-checkbox-group v-model="selectedRejectReasonList" :max="5" @change="changeRejectReasonCheckBox">
                <div
                  v-for="(rejectReason, index) in rejectReasonList"
                  :key="index"
                >
                  <el-checkbox :label="rejectReason"></el-checkbox>
                </div>
              </el-checkbox-group>
              <el-checkbox-group v-model="otherList" @change="changeRejectReasonOther">
                <div
                  v-for="(rejectReasonOther, index) in rejectReasonOtherList"
                  :key="index"
                >
                  <el-checkbox :label="rejectReasonOther"></el-checkbox>
                </div>
              </el-checkbox-group>
              <div v-if="isShowOtherTips" class="review-dialog-reason-other-tips">If the reasons mentioned above do not apply, <span>please contact the ShopVidi team</span> for confirmation. <span>Please refrain from submitting the rejection review temporarily.</span></div>
              <div v-if="showSelectRejectReasonError" class="reject-reason-tips">Please selected reason for rejection</div>
            </div>
            <div class="review-dialog-reject-tips"><span>Friendly Reminder:</span> <span>{{rejectionTips}}</span></div>
            <div class="review-dialog-action">
              <div v-loading="loading" class="review-dialog-cancel" @click="cancle">Cancel</div>
              <div v-loading="loading" class="review-dialog-confirm" @click="confirm">Confirm</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>

import CustomBreadcrumb from '../components/custom-breadcrumb'
import {getAction, putAction} from '@/api/manage.js'
import OrderRejectReason from '../components/order/order-reject-reason.vue'

export default {
  components: {
    CustomBreadcrumb,
    OrderRejectReason
  },
  data() {
    return {
      orderId: '',
      loading: false,
      storeInfo: {
        userId: '',
        email: '',
        phone: '',
        onlineShopType: '',
        storeName: '',
        storeAddress: '',
        googleMapUrl: '',
        exteriorStoreImageList: [], // 店外图
        interiorStoreImageList: [], // 店内图
        googleMapStoreImageList: [], // googleMap上面的图片
        state: '',
        city: '',
        zipCode: '',
        countryCode: '',
        country: '',
        rejectReason: ''
      },
      brandTips: {},
      reviewType: '',
      reviewDialogVisible: false,
      dialogVisible: false,
      dialogImageUrl: '',
      showrejectReasonError: true,
      storeType: [
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x.png',
          textTitle: 'Brick & Mortar Store',
          textSubtitle: 'I sell from my own retail storefront.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%281%29.png',
          textTitle: 'Brick & Mortar and Online Store',
          textSubtitle: 'I sell from both retail stores and online stores.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%282%29.png',
          textTitle: 'Online Boutique Store',
          textSubtitle: 'I only sell from my own unique website.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%283%29.png',
          textTitle: 'Pop-up Store',
          textSubtitle:
            'I sell from a shared marketplace as a vendor, or at events.'
        },
        {
          img: 'https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/shopvidi/Faire.com%20%E2%80%94%20The%20Online%20Wholesale%20Marketplace%20%20Store%402x%20%284%29.png',
          textTitle: 'Social Media',
          textSubtitle: 'I only sell products on other channels'
        }
      ],
      rejectionDesc: '',
      rejectReasonList: [],
      rejectionTips: '',
      selectedRejectReasonList: [],
      isShowOtherTips: false,
      showSelectRejectReasonError: true,
      auditReason: '',
      otherList: [],
      rejectReasonOtherList: [],
      isOperation: false,
      mapsIncorrectFlag: false,
      mapsIncorrectTips: '',
      superUserIdArr: ['1526126197658583041'], // 默认正式用户
      storeAuditGoogleMapUrlSwitchFlag: false,//店铺审核谷歌地址、sdr、报告页开关
    }
  },
  computed: {
    detailAddress() {
      return `${this.storeInfo['storeAddress']}, ${this.storeInfo['city']}, ${this.storeInfo['state']}, ${this.storeInfo['country']}`
    },
  },
  created() {
    if (process.env.NODE_ENV === 'test' || process.env.NODE_ENV === 'development') {
      this.superUserIdArr = ['1642728854895173634','1534004062118182913']
    }
    // 先判断角色
    const role = this.$route.query.role
    let userInfo = JSON.parse(localStorage.getItem('pro__userInfo')).value
    if (role === 'operation') {
      // 如果是运营，则当前用户必须是指定用户,如果不是给出提示
      if (!this.superUserIdArr.includes(userInfo.id)) {
        this.$message.warning('此用户没有权限访问')
        // 返回订单列表
        this.$router.push({path: 'vilocal-order-list'})
        return
      }
      this.isOperation = true
    }
    this.orderId = this.$route.query.orderId
    this.getShopInfo()
    this.getBrand()
    this.loadStoreAuditSwitchConfig()
  },
  methods: {
    changeRejectReasonOther(value) {
      if (value.length > 0) {
        this.isShowOtherTips = true
      } else {
        this.isShowOtherTips = false
      }
    },
    changeRejectReasonCheckBox(value) {
      if (value.length > 0) {
        this.showSelectRejectReasonError = false
      } else {
        this.showSelectRejectReasonError = true
      }
    },
    getBrand() {
      getAction('/vilocal/shop/order/api/v0.2/orders/' + this.orderId + '/brand').then(response => {
        if (response.success) {
          this.brandTips = response.result
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    changeRejectReason(value) {
      value = value.replace(/[^\x00-\xff]/g, '')
      this.storeInfo.rejectReason = value
      if (value) {
        this.showrejectReasonError = false
      } else {
        this.showrejectReasonError = true
      }
    },
    confirm() {
      if (this.loading) {
        return
      }
      const params = {}
      params.isBrandReviewAudit = false
      // 2.2.7.2 增加区分运营审核还是供应商审核
      if (this.isOperation) {
        params.isBrandReviewAudit = true
      }
      params.googleMapUrl = this.storeInfo.googleMapUrl

      if (this.reviewType === 1) {
        // 如果是通过直接调用接口
        this.loading = true
        putAction('/vilocal/shop/order/api/v0.2/brand/orders/' + this.orderId + '/shop/audit/status/2', params).then(response => {
          if (response.success) {
            this.loading = false
            this.$message.success(response.message)
            this.$router.push({path: 'vilocal-order-list'})
          } else {
            this.loading = false
            this.$message.warning(response.message)
          }
        })
      } else if (this.reviewType === 0) {
        // 如果拒绝，那么要验证是否填了拒绝原因 2.2.7 更新文本框隐藏，改成选择
        // if (!this.storeInfo.rejectReason) {
        //   this.showrejectReasonError = true
        //   return
        // }

        // 如果没有选择则不通过
        if (this.showSelectRejectReasonError) {
          return
        }
        let tempSelectedRejectReasonList = []
        // 这里存储的选中的顺序，需要按照配置顺序展示
        for (var index = 0; index < this.rejectReasonList.length; index++) {
          const rejectReasonObject = this.rejectReasonList[index]
          // 按照配置顺序循环，如果选中的里面包含配置项,并且不是最后一个就加进去
          if (this.selectedRejectReasonList.indexOf(rejectReasonObject) > -1) {
            tempSelectedRejectReasonList.push(rejectReasonObject)
          }
        }
        // 将字符串数组转成字符串
        this.storeInfo.rejectReason = tempSelectedRejectReasonList.join('###')
        this.loading = true
        params.auditReason = this.storeInfo.rejectReason
        putAction('/vilocal/shop/order/api/v0.2/brand/orders/' + this.orderId + '/shop/audit/status/3', params).then(response => {
          if (response.success) {
            this.loading = false
            this.$message.success(response.message)
            this.$router.push({path: 'vilocal-order-list'})
          } else {
            this.loading = false
            this.$message.warning(response.message)
          }
        })
      }
      // 回到订单列表
      this.reviewDialogVisible = false
    },
    cancle() {
      this.storeInfo.rejectReason = ''
      this.showrejectReasonError = true
      this.reviewDialogVisible = false
    },
    back() {
      this.cancle()
    },
    checkGoogleMap(){
      if (this.isOperation && this.storeAuditGoogleMapUrlSwitchFlag) {
        if (this.mapsIncorrectFlag) {
          return true;
        }
      }
      return false;
    },
    approved() {
      if (this.checkGoogleMap()) {
          return;
      }

      this.reviewType = 1
      this.reviewDialogVisible = true
    },
    reject() {
      if (this.checkGoogleMap()) {
        return;
      }

      this.reviewType = 0
      this.reviewDialogVisible = true
      // 点击拒绝的按钮，调用接口请求数据
      this.getStoreReasonForRejectionDesc()
      this.getReasonForRejectionList()
      this.getReasonForRejectionTips()
    },
    getStoreReasonForRejectionDesc() {
      getAction('/sys/dict/getDictItems/store_reason_for_rejection_desc').then(response => {
        if (response.success) {
          if (response.result) {
            this.rejectionDesc = response.result[0].value
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    getReasonForRejectionList() {
      this.rejectReasonList = []
      this.rejectReasonOtherList = []
      getAction('/sys/dict/getDictItems/reason_for_rejection_list').then(response => {
        if (response.success) {
          if (response.result) {
            for (var index = 0; index < response.result.length; index++) {
              const value = response.result[index].value
              // 如果最后一个放到rejectReasonOtherList里面
              if (index === response.result.length - 1) {
                this.rejectReasonOtherList.push(value)
              } else {
                this.rejectReasonList.push(value)
              }
            }
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    getReasonForRejectionTips() {
      getAction('/sys/dict/getDictItems/reason_for_rejection_tips').then(response => {
        if (response.success) {
          if (response.result) {
            this.rejectionTips = response.result[0].value
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    getShopInfo() {
      getAction('/vilocal/shop/order/api/v0.2/brand/orders/' + this.orderId).then(response => {
        if (response.success) {
          if (response.result) {
            // 店内场景图
            if (response.result.interiorStoreImageList && response.result.interiorStoreImageList.length > 0) {
              this.storeInfo.interiorStoreImageList = response.result.interiorStoreImageList
            } else {
              this.storeInfo.interiorStoreImageList.push('https://master-shopvidi.s3.amazonaws.com/common/prod/2023111404/not-upload.png')
            }
            // 店外图
            if (response.result.exteriorStoreImageList && response.result.exteriorStoreImageList.length > 0) {
              this.storeInfo.exteriorStoreImageList = response.result.exteriorStoreImageList
            } else {
              this.storeInfo.exteriorStoreImageList.push('https://master-shopvidi.s3.amazonaws.com/common/prod/2023111404/not-upload.png')
            }

            this.storeInfo.userId = response.result.userId
            this.storeInfo.email = response.result.email
            this.storeInfo.phone = response.result.phone
            this.storeInfo.onlineShopType = response.result.onlineShopType
            this.storeInfo.storeName = response.result.storeName
            this.storeInfo.storeAddress = response.result.storeAddress
            this.storeInfo.googleMapUrl = response.result.googleMapUrl
            this.storeInfo.shopId = response.result.shopId
            this.storeInfo.reason = response.result.reason
            this.storeInfo.auditStatus = response.result.auditStatus
            this.storeInfo.brandReviewStatus = response.result.brandReviewStatus
            this.storeInfo.saleSdr = response.result.saleSdr
            this.storeInfo.storeContactName = response.result.storeContactName
            // this.storeInfo.auditReason = response.result.auditReason
            this.auditReason = response.result.auditReason
            // if (response.result.auditReason) {
            //   this.rejectReasonResultList = response.result.auditReason.split('###')
            // }
            // 隐藏字段
            this.storeInfo.state = response.result.state
            this.storeInfo.city = response.result.city
            this.storeInfo.zipCode = response.result.zipCode
            this.storeInfo.countryCode = response.result.countryCode
            this.storeInfo.country = response.result.country
            // this.getGoogleMap()
          }
        } else {
          this.$message.warning(response.message)
        }
      })
    },
    handlePictureCardPreviewUrl(fileUrl) {
      this.dialogImageUrl = fileUrl
      this.dialogVisible = true
    },
    checkGoogleMapUrl(){
      this.mapsIncorrectFlag = false
      if (!this.storeInfo.googleMapUrl) {
        this.mapsIncorrectTips = "Please enter the map address."
        this.mapsIncorrectFlag = true
        return
      }

      if (!this.storeInfo.googleMapUrl.includes("maps") || this.storeInfo.googleMapUrl.includes("<a")) {
        this.mapsIncorrectTips = "The Google Maps address is incorrect. Please verify and corrrect it, or notify the sales department to make the necessary changes."
        this.mapsIncorrectFlag = true
      }


    },
    changeGoogleMapUrl(e){
      this.checkGoogleMapUrl()
    },
    gotoReport() {
      let encrypt = btoa(this.storeInfo.googleMapUrl)
      const routeUrl = this.$router.resolve(`/menu/Explore?isReport=1&userId=${this.storeInfo.userId}&storeId=${encrypt}`)
      window.open(routeUrl.href, '_blank')
    },
    loadStoreAuditSwitchConfig() {
      getAction('/sys/dict/getDictItems/store_audit_google-sdr-report_switch').then(response => {
        if (response.success) {
          let objArr = response.result;
          if (objArr) {
            this.storeAuditGoogleMapUrlSwitchFlag = objArr[0].value == '1';
          }
        }
      })

    },

  }
}
</script>

<style lang="less" scoped>
.review-reject{
  width: 80%;
  min-width: 490px;
  margin:0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .review-reject-title{
    font-size: 16px;
    font-family: Satoshi-Medium;
    color: #FF4812;
    opacity: 1;
  }
  .review-reject-text{
    margin-top: 20px;
    // text-align: left;
    // font-size: 14px;
    // font-family: Satoshi-Medium;
    // line-height: 20px;
    // color: #FF4812;
    // opacity: 1;
  }
}
.reject-reason-tips{
  color: #F77073;
}
.review-dialog-border{
  width: 96%;
  margin:0 auto;
}
.review-dialog-back{
  width: 10%;
  font-size: 14px;
  font-family: Satoshi-Medium !important;
  cursor: pointer;
  color: #262B2F;
  padding: 20px 0px 10px 0px;
}
.review-dialog-tips{
  width: 95%;
  margin: 0 auto;
  font-size: 14px;
  font-family: Satoshi-Medium !important;
  line-height: 20px;
  color: #000000;
  opacity: 1;
  span{
    margin-left: 10px;
    font-size: 14px;
    color: #5D5D5D;
    font-family: Satoshi-Regular;
  }
}
.review-dialog-desc{
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;
  font-size: 14px;
  color: #262B2F;
  font-family: Satoshi-Regular;
}
.review-dialog-reason-list{
  width: 95%;
  margin: 0 auto;
  margin-top: 20px;
  /deep/  .el-checkbox__label{
    color: #5D5D5D;
    font-family: Satoshi-Regular;
    margin:10px 0px
  }
  .review-dialog-reason-other-tips{
    margin-left: 25px;
    font-family: Satoshi-Regular;
    font-size: 14px;
    color: #000000;
    span{
      font-family: Satoshi-Bold !important;
    }
  }
}
.review-dialog-reject-tips{
  width: 95%;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 14px;
  color: #FB541C;
  span:nth-child(2){
    font-family: Satoshi-Regular;
  }
  span:nth-child(1){
    font-family: Satoshi-Bold !important;
  }
}
.review-dialog-reason{
  width: 95%;
  margin: 0 auto;
  margin-top: 10px;
  /deep/ .el-textarea__inner:focus{
    border-color:#707070
  }
  /deep/ .el-textarea__inner{
    height: 100px !important;
  }
}

.review-dialog-action{
  width: 95%;
  margin:0 auto;
  margin-top: 20px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .review-dialog-cancel,.review-dialog-confirm{
    width: 48%;
    height: 41px;
    border: 1px solid #707070;
    opacity: 1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Satoshi-Medium !important;
    cursor: pointer;
  }
  .review-dialog-cancel{
    background:#FFFFFF
  }
  .review-dialog-confirm{
    background:#262B2F;
    color:#FFFFFF
  }
}
.store_review_box{
  margin-top: 10px;
}
.store_review_title{
  margin: 0px 30px 20px 0px !important;
  height: 35px;
  line-height: 35px;
  margin-right: 0px !important;
}
.brand-tips{
  margin:25px 0px;
  display: flex;
  .brand-tips-img-border{
    max-width: 107px;
    width: 24%;
    // height: 107px;
    .brand-tips-img{
      width: 100%;
      // height: 100%;
      border: 1px solid #E1E1E1;
      border-radius: 50%;
    }
  }
  .brand-tips-main{
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .brand-tips-title{
      font-size: 18px;
      font-family: Satoshi-Medium !important;
      color: #000000;
      opacity: 1;
    }
    .brand-tips-text{
      font-size: 14px;
      font-family: Satoshi-Regular;
      color: #000000;
      opacity: 1;
    }
    .brand-tips-content{
      font-size: 14px;
      font-family: Satoshi-Medium !important;
      color: #000000;
      opacity: 1;
    }
  }
}
.store-image{
  border: 1px solid #e1e1e1;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  cursor: pointer;
  object-fit: cover;
}
.sit_img {
  width: 10.33px;
  height: 12.33px;
}
.store-name-input-main1{
  width: 100%;
}
.store-info {
  width: 50%;
  margin: 0 auto;
  .store-info-review{
    width: 100%;
    margin:0 auto;
    margin-bottom: 20px;
    text-align: center;
    font-size: 24px;
    font-family: Satoshi-Regular;
    color: #262B2F;
    opacity: 1;
  }
  .store-info-title {
    font-size: 14px;
    font-family: Satoshi-Medium !important;
    font-weight: 500;
    line-height: 30px;
    color: #262b2f;
    opacity: 1;
    border-bottom: 1px solid #e1e1e1;
  }
  .button,.button-skip {
    height: 50px;
    line-height: 50px;
    text-align: center;
    color: #ffffff;
    background: #000000;
    opacity: 1;
    border-radius: 2px;
    cursor: pointer;
  }
  .button-skip{
    background:#FFFFFF;
    color:#000000;
    border: 1px solid #000000;
    margin-top: 10px;
  }
}
.store-info-form {
  margin-top: 20px;
  .el-form-item {
    margin-bottom: 20px;
  }
}

.el-select{
  width: 100%;
}
.inp-list {
  margin-bottom: 30px;
  .inp-item {
    display: flex;
    flex-direction: column;

    margin-top: 10px;
    .inp-item-title {
      display: flex;
      align-items: center;
    }
    .inp-item-cont3 {
      height: 300px !important;
      .application-tips{
        font-size: 12px;
        font-family: Satoshi-Medium !important;
        line-height: 20px;
        color: #FF4812;
        opacity: 1;
      }
    }
    .inp-item-cont {
      height: 40px;
      margin-top: 10px;
      .upload-tips-text {
        font-size: 14px;
        color: #5d5d5d;
        margin-bottom: 10px;
      }
      .upload-tips-text2 {
        margin-top: 10px;
      }
      .inp-textarea {
        width: 374px;
        border: 1px solid #e1e1e1;
        padding: 10px;
        outline: none;
      }
      .inp-textarea2 {
        margin-top: 10px;
      }
      .inp {
        display: flex;
        width: 100%;
        i {
          cursor: pointer;
          width: 10%;
          border: 1px solid #e1e1e1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .add-address {
          border: 1px solid #e1e1e1;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 40px;
          cursor: pointer;
        }
      }
      .el-select {
        width: 100%;
      }
    }
    .shop-url-list {
      border-bottom: 1px solid #e1e1e1;
      margin-bottom: 20px;
      .shop-url {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 10px 0px;
      }
    }
    p {
      font-size: 14px;
      line-height: 20px;
      color: #262b2f;
      opacity: 1;
    }
    .el-upload {
      margin: 20px 0px;
    }
  }
  .application-title{
    font-size: 14px;
    font-family: Satoshi-Regular;
    line-height: 20px;
    margin-bottom: 10px;
    color: #262B2F;
    opacity: 1;
  }
  .google-maps-title{
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    span{
      font-weight: 700;
    }

  }
  .error-googleurl{
    margin-top: 5px;
    margin-bottom: 30px;
  }
  .store-report{
    margin-top: 20px;
    span{
      font-weight: 600;
      margin-right: 10px;
    }
  }
  .store-report-btn{
    width: 120px;
    height: 30px;
    line-height: 30px;
    background: #262B2F;
    border-radius: 5px;
    cursor: pointer;
    color: #FFFFFF;
    text-align: center;
    padding: 0 5px;
  }



}

.action{
  display: flex;
  align-items: center;
  justify-content: space-around;
  .pass-button,.reject-button{
    width:230px;
    height: 50px;
    background: #262B2F;
    opacity: 1;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    cursor: pointer;
  }
}
.simple-head{
  display: flex;
  .hide{display: none;}
  .simple-img{
    width: 148px;
    height: 148px;
    cursor:pointer;
    object-fit: cover;
  }
}

.error-tips{
  line-height: 20px;
  height: 20px;
  font-size: 12px;
  color: #F77073;
}
/deep/ .el-dialog{
  width: 640px;
}
#el-dialog-img{
  /deep/ .el-dialog__body{
    height: 375px;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/order/store-review.vue